import { getEnv } from "config/Config";
import { eaFetch } from "services/common/ApiUtils";


export async function getOwlinMonitoring(accountId, thirdpartyId, dispatch) {
  return eaFetch(
    dispatch,
    getEnv("REACT_APP_EDGE"),
    "GET",
    `365/account/${accountId}/thirdparties/${thirdpartyId}/owlin`
  );
}

export async function updateOwlinMonitoring(accountId, thirdpartyId, owlinData, dispatch) {
  return eaFetch(
    dispatch,
    getEnv("REACT_APP_EDGE"),
    "PUT",
    `365/account/${accountId}/thirdparties/${thirdpartyId}/owlin`,
    owlinData
  );
}

export async function deactivateOwlin(accountId, thirdpartyId, dispatch) {
  return eaFetch(
    dispatch,
    getEnv("REACT_APP_EDGE"),
    "DELETE",
    `365/account/${accountId}/thirdparties/${thirdpartyId}/owlin`
  );
}

export async function activateOwlin(accountId, thirdpartyId, dispatch) {
  return eaFetch(
    dispatch,
    getEnv("REACT_APP_EDGE"),
    "POST",
    `365/account/${accountId}/thirdparties/${thirdpartyId}/owlin/activation`
  );
}

export async function createRestrictedToken(accountId, thirdpartyId, dispatch) {
  return eaFetch(
    dispatch,
    getEnv("REACT_APP_EDGE"),
    "POST",
    `365/account/${accountId}/thirdparties/${thirdpartyId}/owlin/restrictedtoken`
  );
}
  